module.exports = __webpack_public_path__ + "static/media/intro.d69578cf.mp3";